import { Component, Inject, TemplateRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SafeHtml } from '@angular/platform-browser';

export type ActionPromptConfig = {
  title?: string;
  icon?: string;
  matIcon?: string;
  matIconFontSet?: string;
  heading?: string;
  message?: string;
  centeredMessage?: string;
  messages?: string[];
  messageTml?: TemplateRef<unknown>;
  messageHtml?: SafeHtml;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  messageContext?: any;
  // actions
  // confirm action
  confirmActionCaption?: string;
  removeConfirmAction?: boolean;
  disableConfirmWhile?: () => boolean;
  onConfirm?: () => Promise<void>;
  awaitOnConfirm?: boolean;
  // cancel action
  cancelActionCaption?: string;
  removeCancelAction?: boolean;
  otherActionCaption?: string;
  onCancel?: () => Promise<void>;
  awaitOnCancel?: boolean;

  disableClose?: boolean;
};

@Component({
  selector: 'app-action-prompt',
  templateUrl: './action-prompt.component.html',
  styleUrls: ['./action-prompt.component.scss'],
  standalone: false,
})
export class ActionPromptDialog {
  protected waitingConfirmCallback = false;
  protected waitingCancelCallback = false;

  constructor(
    public readonly dialogRef: MatDialogRef<ActionPromptDialog>,
    @Inject(MAT_DIALOG_DATA) public prompts: ActionPromptConfig
  ) {
    if (this.prompts.disableClose) this.dialogRef.disableClose = true;
  }

  onConfirm(): void {
    if (this.prompts.onConfirm) {
      this.waitingConfirmCallback = true;
      this.prompts
        .onConfirm()
        .then(() => {
          if (this.prompts.awaitOnConfirm) this.dialogRef.close(true);
          this.waitingConfirmCallback = false;
        })
        .catch(() => {
          this.dialogRef.close(true);
          this.waitingConfirmCallback = false;
        });
    }
    if (!this.prompts.onConfirm || !this.prompts.awaitOnConfirm) this.dialogRef.close(true);
  }

  onCancel(): void {
    if (this.prompts.onCancel) {
      this.waitingCancelCallback = true;
      this.prompts
        .onCancel()
        .then(() => {
          if (this.prompts.awaitOnCancel) this.dialogRef.close(false);
          this.waitingCancelCallback = false;
        })
        .catch(() => {
          this.dialogRef.close(false);
          this.waitingCancelCallback = false;
        });
    }
    if (!this.prompts.onCancel || !this.prompts.awaitOnCancel) this.dialogRef.close(false);
  }

  onOther(text: string): void {
    this.dialogRef.close(text);
  }
}
